import { useCallback } from 'react';
import { useQueryParam } from 'use-query-params';
import { QueryParamConfig } from 'serialize-query-params';
import { UrlUpdateType } from 'use-query-params/lib/types';

/**
 * `useQueryParam` defaulting to `'pushIn'` instead of `'replaceIn'`, so user-initiated changes add a
 * history entry and the back button works. Pass `'replaceIn'` to the setter for programmatic updates.
 */
export const useQueryParamWithHistory = <D, D2 = D>(
  name: string,
  paramConfig?: QueryParamConfig<D, D2>,
): [D2 | undefined, (newValue: D, updateType?: UrlUpdateType) => void] => {
  const [value, setValue] = useQueryParam(name, paramConfig);

  const setWithHistory = useCallback(
    (newValue: D, updateType: UrlUpdateType = 'pushIn') => {
      setValue(newValue, updateType);
    },
    [setValue],
  );

  return [value, setWithHistory];
};
